module.exports = __webpack_public_path__ + "img/tyuusha.d0415b46.png";